module.exports = __webpack_public_path__ + "img/privacy_person.1e98d78a.png";